var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFlagEng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-12%",
    y: "-30%",
    width: "124%",
    height: "160%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    x: 0,
    y: 0,
    width: 21,
    height: 18,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    transform: "translate(-3 -8)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFF",
    x: -0.5,
    y: -0.5,
    width: 22,
    height: 19,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00549B",
    fillRule: "nonzero",
    mask: "url(#c)",
    d: "M-6.888.112v17.785H27.57V.112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 2.205 27.112 20.12l1.57-3.205L-6.43-1-8 2.205zM27.112-1-8 16.915l1.57 3.205L28.682 2.205 27.112-1z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)",
    fill: "#FE333F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-7.007 1.588 34.77 18.103 1.037-2.159L-5.97-.571l-1.037 2.159zm34.77-2.159-34.77 18.103 1.037 2.159L28.8 1.588 27.764-.571z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.47.112v17.785h5.743V.112H7.469zM-6.889 11.968H27.57V6.04H-6.89v5.928z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.064.112v7.114H27.57v3.557H12.064v7.114H8.618v-7.114H-6.888V7.226H8.618V.112h3.446z",
    fill: "#FE333F",
    fillRule: "nonzero",
    mask: "url(#c)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEng);
export default __webpack_public_path__ + "static/media/flag-eng.ff2f0f48ccad3bbaa77fa64cc0a55771.svg";
export { ForwardRef as ReactComponent };